import { t } from "@/shared/i18n";

interface Props {
  currentScore: number;
  highScore: number;
  multiplier: number;
  isAuthenticated: boolean;
}

export const ScoreDisplay = ({ currentScore, highScore, multiplier, isAuthenticated }: Props) => {
  if (!isAuthenticated) {
    return (
      <div className="fixed top-20 left-4 text-black" data-testid='score_display_unlogged'>
        <div className="text-sm text-accent-yellow text-end">
          {t('gamification.login_to_track')}
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-20 left-4 text-black" data-testid='score_display'>
      <div className="text-2xl font-bold text-end" data-testid='score_display_currentScore'>
        {t('gamification.score')} {currentScore.toLocaleString()}
      </div>
      <div className="text-sm text-zinc-700 text-end" data-testid='score_display_highestScore'>
        {t('gamification.highest_score')} {highScore.toLocaleString()}
      </div>
      <div className="text-accent-yellow text-sm text-end">
        <span>x</span>
        <span data-testid='score_display_multiplier' className="mr-2">{multiplier.toFixed(1)}</span>
        <span>{t('gamification.multiplier')}</span>
      </div>
    </div>
  );
};